module.exports = "<div>\n  <div class=\"content-box\" *ngIf=\"isOpen\">\n    <ng-content></ng-content>\n  </div>\n  <a id=\"booking-details-btn-hide-details-{{itemIndex}}\" (click)=\"toggleContent()\" [ngClass]=\"{'hide-detail': isOpen, 'show-detail': !isOpen}\">\n    {{ (isOpen? 'booking-details-hide-details': 'booking-details-view-more-details') | translate}}\n  </a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/roomtype-item/roomtype-item.component.html
// module id = 1083
// module chunks = 22